import React, { useRef, useState, useEffect } from "react";
import { withRouter } from "../../app-services/lib/router-compat";
import CheckoutSteps from "../preview/CheckoutSteps/CheckoutSteps";
import HTMLFlipBook from "react-pageflip";
import "./HandprintView.css";

export function HandprintView(props) {
  const { onFetch: onFetchProp = (...arg) => api.getSelfPublish(...arg) } = props;
  const onFetchRef = useRef(onFetchProp);
  onFetchRef.current = onFetchProp;
  const CUSTOMBOOKID = props.bookDetails.id;
  const $ele = useRef(null);

  const [state, setStateRaw] = useState({
    pages: [],
    bookDetails: null,
    productDetails: null,
    answers: {},
    parsedBook: null,
    bookobj: null,
  });

  const setState = (partial) => {
    setStateRaw((prev) => ({ ...prev, ...partial }));
  };

  const instanceRef = useRef(null);
  if (!instanceRef.current) {
    instanceRef.current = {};
  }
  const self = instanceRef.current;

  self.onFetch = (...args) => onFetchRef.current(...args);

  self.onBookSetup = (bookobj) => {
    setState({ bookobj });
    let previewPageNo = localStorage.getItem("previewPageNo");
    if (previewPageNo) {
      setTimeout(() => {
        bookobj.turnToPage(Number(previewPageNo));
        localStorage.removeItem("previewPageNo");
      }, 100);
    }
  };

  self.getPages = () => {
    let { getPayload } = self.props;
    return new Promise((resolve, reject) => {
      getPayload()
        .then((book) => {
          resolve(
            Object.entries(book).map(([key, value], i) => ({
              pagetype: key,
              name: key,
              label: i + 1,
              content: value.html,
            }))
          );
        })
        .catch((err) => reject(err));
    });
  };

  self.getProductDetails = () => {
    let { bookDetails } = self.props;
    api.getBookDetails(bookDetails.bookId).then((res) => {
      setState({
        productDetails: res.data.bookDetails,
      });
    });
  };

  self.getBookDetails = () => {
    let { bookDetails } = self.props;
    return new Promise((resolve, reject) => {
      if (bookDetails.id) {
        self.onFetch(bookDetails.id).then((response) => {
          if (response.data && Object.keys(response.data).length) {
            let savedBookObj = response.data || { savedBook: "{}" };
            let parsedBook = JSON.parse(savedBookObj.savedBook || "{}") || {};
            setState({
              bookDetails: savedBookObj,
              parsedBook,
            });
            resolve(savedBookObj);
          }
        });
      }
    });
  };

  self.onPage = (obj, i, arr) => {
    return {
      ...obj,
      content: () => (
        <div>
          <div dangerouslySetInnerHTML={{ __html: obj.content || "" }}></div>
          <div className="col text-center">
            <b>{obj.label}</b> / {arr.length}
          </div>
        </div>
      ),
    };
  };

  self.onAnswer = (value, key) => {
    let { answers } = self.state;
    let { onUpdate } = self.props;
    if (key === "dedication") {
      onUpdate(key, value);
    }
    setState({
      answers: {
        ...answers,
        [key]: value,
      },
    });
  };

  self.onDedicationSave = () => {
    let { saveBook, bookname } = self.props;
    return new Promise((resolve, reject) => {
      saveBook()
        .then(() => {
          setTimeout(() => {
            if (bookname === "customcharacter-book") {
              localStorage.setItem("previewPageNo", 18);
            }
            resolve();
          }, 100);
        })
        .catch(reject);
    });
  };

  self.checkoutSave = () => {
    return new Promise((resolve, reject) => {
      self.onDedicationSave().then(() => {
        let { bookDetails } = self.state;
        setState({
          productDetails: { ...bookDetails, triggeradd2cart: true },
        });
      });
    });
  };

  self.addToCart = () => {
    let { productDetails, answers, bookDetails } = self.state;
    let { saveBook, getPayload, history } = self.props;
    mixins.checkLogin(history).then(async (user) => {
      if (!productDetails) {
        self.checkoutSave();
        return;
      } else {
        let payload = await getPayload();
        await emit.trigger("updatebook", payload);
      }

      if (localStorage.getItem("editmode") === "true") {
        api
          .updateToCart(
            {
              promotionId: null,
              productId: productDetails?.product?.id,
              quantity: 1,
              price: productDetails?.book?.bookPrice,
              discount: null,
              bookCover: answers.cover || null,
              customProductId: self.props.store.cartdetails?.customProductId,
            },
            self.props.store.cartdetails?.id
          )
          .then((res) => {
            localStorage.setItem("editmode", false);
            if (res && res.statusCode === 200) {
              history.push("/checkout-page");
            } else {
              alert("Something went wrong please try again later..");
            }
          });
      } else {
        api
          .addToCart({
            promotionId: null,
            productId: productDetails?.product?.id,
            quantity: 1,
            price: productDetails?.book?.bookPrice,
            discount: null,
            bookCover: answers.cover || null,
            customBookId: bookDetails.customBook.id,
          })
          .then((res) => {
            if (res && res.statusCode === 200) {
              history.push("/checkout-page");
              mixins.reFetchSavedBookDetails(self.props);
            } else {
              alert("Something went wrong please try again later..");
            }
          });
      }
    });
  };

  Object.assign(self, {
    props,
    state,
    setState,
    $ele,
    CUSTOMBOOKID,
    history: props.history,
  });

  self.getStepKeys = () => {
    switch (props.bookname) {
      case "world-book":
        return ["edit", "dedication"];
      case "handprint-book":
        return ["edit"];
      default:
        return [];
    }
  };

  self.props = props;
  initialConstruct.bind(self)("BookPreview", props);

  useEffect(() => {
    window.HandprintView = self;
    self.getPages().then((pages) => {
      setState({ pages });
      self.getBookDetails().then(() => {
        self.getProductDetails();
      });
    });
  }, []);

  const { bookname } = props;
  const { pages } = state;

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-10 offset-md-1">
          <div className={`bookView handprintcus ${bookname}`}>
            {pages.length > 0 && (
              <HTMLFlipBook
                width={200}
                height={200}
                size="stretch"
                maxShadowOpacity={0.5}
                showCover={true}
                mobileScrollSupport={true}
                className="demo-book"
              >
                {pages.map((o, index) => {
                  return (
                    <div
                      key={index}
                      className={`demoPage ${
                        index === 0
                          ? "front-page"
                          : index === pages.length - 1
                          ? "backcover"
                          : index % 2 === 1
                          ? "left-page"
                          : "right-page"
                      }`}
                      style={{ position: "relative" }}
                      dangerouslySetInnerHTML={{ __html: o?.content }}
                    ></div>
                  );
                })}
              </HTMLFlipBook>
            )}
          </div>
        </div>
      </div>

      <div className="row mt-5">
        <div className="col-md-12">
          <CheckoutSteps
            keys={self.getStepKeys()}
            addToCart={() => self.addToCart()}
            onAnswer={(v, k) => self.onAnswer(v, k)}
            onSave={(v) => self.onDedicationSave(v)}
            bookname={bookname}
          />
        </div>
      </div>
    </div>
  );
}

export default withRouter(HandprintView);
